import React from "react";
import { Link } from "react-router-dom";
import { COMPANY_INFO, NAVIGATION_LINKS } from "../data/siteData";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-slate-700 border-t border-slate-200">
      {/* Main Footer Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Col 1: About & Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=360,quality=95,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/logo.png"
                alt="NF-Polering Logo"
                className="h-14 sm:h-16 w-auto object-contain"
              />
            </Link>
            <div className="text-xs text-slate-500 space-y-0.5">
              <p>{COMPANY_INFO.openingHoursWeekdays}</p>
              <p>{COMPANY_INFO.openingHoursWeekend}</p>
            </div>
          </div>

          {/* Col 2: Services */}
          <div>
            <h4 className="text-xs font-bold tracking-wider text-slate-950 uppercase mb-3">
              Ydelser
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/vinduespudsning"
                  className="text-slate-600 hover:text-cyan-600 transition-colors"
                >
                  Vinduespolering
                </Link>
              </li>
              <li>
                <Link
                  to="/solcellevask"
                  className="text-slate-600 hover:text-cyan-600 transition-colors"
                >
                  Solcellevask
                </Link>
              </li>
              <li>
                <Link
                  to="/fliserens"
                  className="text-slate-600 hover:text-cyan-600 transition-colors"
                >
                  Fliserens
                </Link>
              </li>
              <li>
                <Link
                  to="/om-os"
                  className="text-slate-600 hover:text-cyan-600 transition-colors"
                >
                  Om os
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="text-slate-600 hover:text-cyan-600 transition-colors"
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Local Window Cleaning Areas */}
          <div>
            <h4 className="text-xs font-bold tracking-wider text-slate-950 uppercase mb-3">
              Dækningsområder
            </h4>
            <div className="flex flex-wrap gap-x-2 gap-y-1 text-xs text-slate-600 mb-2.5">
              {[
                { label: "Slagelse", href: "/vinduespudser-slagelse" },
                { label: "Slots Bjergby", href: "/vinduespudser-slots-bjergby" },
                { label: "Sorø", href: "/vinduespudser-soroe" },
                { label: "Skælskør", href: "/vinduespudser-skaelskoer" },
                { label: "Ringsted", href: "/vinduespudser-ringsted" },
                { label: "Næstved", href: "/vinduespudser-naestved" },
                { label: "Dalmose", href: "/vinduespudser-dalmose" },
                { label: "Høng", href: "/vinduespudser-hoeng" },
                { label: "Fuglebjerg", href: "/vindusepudser-fuglebjerg" },
                { label: "Karrebæksminde", href: "/vindusepudser-karrebaeksminde" }
              ].map((sub, i, arr) => (
                <span key={sub.href} className="inline-flex items-center">
                  <Link
                    to={sub.href}
                    className="hover:text-cyan-600 transition-colors"
                  >
                    {sub.label}
                  </Link>
                  {i < arr.length - 1 && <span className="ml-2 text-slate-300">•</span>}
                </span>
              ))}
            </div>
            <Link
              to="/daekningsomraader"
              className="inline-flex items-center gap-1 text-xs font-bold text-slate-900 hover:text-cyan-600 transition-colors"
            >
              <span>Se alle områder</span>
              <i className="fa-solid fa-arrow-right text-[9px]" aria-hidden="true" />
            </Link>
          </div>

          {/* Col 4: Direct Contact */}
          <div>
            <h4 className="text-xs font-bold tracking-wider text-slate-950 uppercase mb-3">
              Kontakt
            </h4>
            <div className="space-y-2.5 text-sm">
              <a
                href={COMPANY_INFO.phoneTel}
                className="flex items-center gap-2 text-slate-700 hover:text-cyan-700 font-semibold"
              >
                <i className="fa-solid fa-phone text-cyan-600 text-xs shrink-0" aria-hidden="true" />
                <span>{COMPANY_INFO.phone}</span>
              </a>

              <a
                href={`mailto:${COMPANY_INFO.email}`}
                className="flex items-center gap-2 text-slate-600 hover:text-cyan-700"
              >
                <i className="fa-solid fa-envelope text-cyan-600 text-xs shrink-0" aria-hidden="true" />
                <span>{COMPANY_INFO.email}</span>
              </a>

              <div className="flex items-center gap-2 text-slate-600 text-xs">
                <i className="fa-solid fa-location-dot text-cyan-600 text-xs shrink-0" aria-hidden="true" />
                <span>{COMPANY_INFO.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {currentYear} {COMPANY_INFO.name} — Alle rettigheder forbeholdes. CVR: {COMPANY_INFO.cvr}</p>
          <div className="flex items-center gap-6">
            <Link to="/handelsbetingelser" className="hover:text-cyan-600 transition-colors">
              Handelsbetingelser
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
